export default __webpack_public_path__ + "static/meredith-d8c6d2cab788ba2b0dc6dff0d47e63f8.png";